module.exports = __webpack_public_path__ + "static/img/8.1f131e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/8.jpg
// module id = J9be
// module chunks = 0